import { render, staticRenderFns } from "./changephone.html?vue&type=template&id=a66e3d56&scoped=true&"
import script from "./changephone.js?vue&type=script&lang=js&"
export * from "./changephone.js?vue&type=script&lang=js&"
import style0 from "./changephone.sass?vue&type=style&index=0&id=a66e3d56&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66e3d56",
  null
  
)

component.options.__file = "changephone.vue"
export default component.exports